module.exports = __webpack_public_path__ + "df357500ce42d95260531fe29b9dc81a.glb";